var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar"},[_vm._m(0),_c('Section',{attrs:{"option":_vm.sidebar.info}}),_c('Section',{attrs:{"option":_vm.sidebar.socials}}),_c('Section',{attrs:{"option":_vm.sidebar.languages}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"avatar-container"}},[_c('img',{attrs:{"id":"avatar"}}),_c('h5',{attrs:{"id":"name"}},[_c('b',[_vm._v("Patcharawat Wongvasinkul")])])])
}]

export { render, staticRenderFns }